import React from "react";
import { CssBaseline } from "@mui/material";

import LessonAppBar from "../components/lessons/LessonAppBar";
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="bg-gray-50">
      <CssBaseline />
      <LessonAppBar />
      <div className="mt-16">{children}</div>
    </div>
  );
};

export default Layout;
